import React from 'react';
import { useAppParams } from '@forvalter/packages/appParams/useAppParams';
import { useCurrentUser } from '@klp/auth';
import { AuthRoutes } from '@klpkonsern/auth-core/routes';
import { Tooltip } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { IconButton } from '@material-ui/core';
import { useHistory } from 'react-router';

import { useLayoutContext } from '@klp/layout/Layout/LayoutContext';
export const HeaderToolbarLogin = () => {
    const history = useHistory();
    const { currentUser, currentUserIsLoading } = useCurrentUser();
    const { matchRoute } = useAppParams();
    const { isMobile } = useLayoutContext();
    const handleRedirectToLogin = () => {
        history.replace(AuthRoutes.login);
    };

    if (currentUserIsLoading) return null;
    if (currentUser) return null;
    if (isMobile) return null;
    if (matchRoute(AuthRoutes.login)) return null;

    return (
        <Tooltip translation="auth.login" title="">
            <IconButton onClick={handleRedirectToLogin} color="secondary">
                <Illustration icon={IconName.LOGIN_REQUIRED} klpColor="main" />
            </IconButton>
        </Tooltip>
    );
};
